export const fetchCountry = async () => {
  return await fetch('https://storage.googleapis.com/sconchat/static/country.json');
};

export const fetchServerDate = async (): Promise<string> => {
  const res = await fetch(`https://storage.googleapis.com/sconchat/static/sconchat.json?t=${Date.now()}`);
  const date = res.headers.get('Date');

  if (!date) {
    throw new Error();
  }

  return date;
};
